<div class="customer-details-card p-20">

    <app-card cardTitle="{{'SendWhatsup' | translate}}" [padding]="20">
        <ng-template #headerOptionsTemplate>
            <a href="javascript:" class="text-muted" mat-dialog-close>
                <i class="ti ti-x f-20"></i>
            </a>
        </ng-template>
        <div class="personal-details">
            <div class="row">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-sm-9">
                            <mat-form-field appearance="outline" class="w-100 m-t-5">
                                <input type="text" matInput
                                    placeholder="{{'enter' | translate}} {{'message' | translate}}" />
                            </mat-form-field>
                        </div>
                        <div class="col-sm-3">
                            <button mat-flat-button class="w-100 m-t-5" color="primary" (click)="send()">{{'send' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </app-card>

</div>